const collaborator =[{
    name:"volkswagen",
    image:"volkswagen.jpg"
},
{
    name:"mozilla",
    image:"mozilla.jpg"
},
{
    name:"iiit palakkad",
    image:"iit_palakkad.jpeg"
},

]
export default collaborator;